import postal from 'postal';
import { PageStrings } from '@alltrails/shared/utils/constants/pageStringHelpers';
import { EditTrailBox } from './edit_trail_box';
import { EditTrailEndBox } from './edit_trail_end_box';
import ContributeMap from './contribute_map';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import { getFormattedTrailUrls } from '../../../../utils/trail_helpers';
import { Page } from '../../../../components/shared/Page/Page';
import { MapExpandProvider } from 'components/MapExpandControl/MapExpandProvider';
import useFeatures from 'hooks/useFeatures';

const createReactClass = require('create-react-class');

const ContributeTrailApp = createReactClass({
  getInitialState() {
    this.resultCardFunctions = {
      handleTrailClick: this.handleTrailClick,
      formatTrailUrl: this.formatTrailUrl
    };

    const { trail } = this.props;
    let defaultMap;
    let defaultPhoto;
    if (trail) {
      defaultMap = trail.defaultMap;
      defaultPhoto = trail.defaultPhoto;
      // Ensure trailId is on the defaultMap
      // (it may not because defaultMap is usually the trail planner map BEFORE being converted to a verified route)
      if (defaultMap && !defaultMap.trailId) {
        // trail_id is given as "id" from trail_medium_presenter
        defaultMap.trailId = trail.id;
      }
    }
    return {
      contributeState: trail ? 'editTrailActive' : 'editTrailStart',
      defaultMap,
      defaultPhoto,
      routeInfo: null, // in-progress trail planner routeInfo
      insertRouteInfo: null, // in-progress trail planner insert routeInfo (for cut and insert modes)
      hasAdminFeatures: this.props.context?.adminUser && useFeatures().includes('contribute_route_drawing_improvements')
    };
  },
  handleWaypointAdded(waypoint) {
    this.setState({ defaultMap: { ...this.state.defaultMap, waypoints: [...this.state.defaultMap.waypoints, waypoint] } });
  },
  handleTrailClick(trail) {
    // Open Trail SEO Pages in new window instead of default behavior (opening up Explore trail page)
    window.open(this.formatTrailUrl(trail), '_blank');
  },
  formatTrailUrl(trail) {
    return getFormattedTrailUrls(trail, this.props.context.languageRegionCode).localizedUrl;
  },
  handleRouteInfoChanged(routeInfoChanges) {
    if (!routeInfoChanges) {
      this.setState({ routeInfo: null });
      return;
    }
    let { routeInfo } = this.state;
    routeInfo = routeInfo ? { ...routeInfo, ...routeInfoChanges } : routeInfoChanges;
    this.setState({ routeInfo });
  },
  handleInsertRouteInfoChanged(routeInfoChanges) {
    if (!routeInfoChanges) {
      this.setState({ insertRouteInfo: null });
      return;
    }
    let { insertRouteInfo } = this.state;
    insertRouteInfo = insertRouteInfo ? { ...insertRouteInfo, ...routeInfoChanges } : routeInfoChanges;
    this.setState({ insertRouteInfo });
  },
  handleMapChange(defaultMap) {
    this.setState({ defaultMap });
  },
  setMapData({ center, zoom }) {
    this.setState({ center, zoom });
  },
  setMapInitialData({ center, zoom }) {
    this.setState({ center, zoom });
  },
  endEditTrail() {
    this.setState({ contributeState: 'editTrailEnd' });
  },
  handleAddTrailClick() {
    const url = LanguageSupportUtil.wrapUrlSafe(
      `/trail/new?latitude=${this.state.center?.[0]}&longitude=${this.state.center?.[1]}&zoom=${this.state.zoom}`,
      this.props.context.languageRegionCode
    );
    window.open(url, '_blank');
  },
  render() {
    // Render welcome, contribute or end box over map
    let contributeBox = null;
    if (this.state.contributeState == 'editTrailActive') {
      contributeBox = (
        <EditTrailBox
          adminUser={this.props.context ? this.props.context.adminUser : null}
          allowNameEditing={this.props.allowNameEditing}
          context={this.props.context}
          currentCity={this.props.currentCity}
          displayMetric={this.props.context ? this.props.context.displayMetric : null}
          handleAddTrailClick={this.handleAddTrailClick}
          hasAdminFeatures={this.state.hasAdminFeatures}
          key={`editTrail-${this.props.trail.id}`}
          mapCenter={this.state.center}
          messagingChannel={this.props.messagingChannel}
          nextTrailCallback={this.endEditTrail}
          rapidRoute={this.props.rapidRoute}
          routeInfo={this.state.routeInfo}
          insertRouteInfo={this.state.insertRouteInfo}
          trail={this.props.trail}
          handleMapChange={this.handleMapChange}
          useMapAsRoute={this.state.defaultMap}
        />
      );
    } else if (this.state.contributeState == 'editTrailEnd') {
      contributeBox = <EditTrailEndBox key="editTrailEnd" trail={this.props.trail} context={this.props.context} />;
    }

    // Convert trail data to Algolia format
    const { id, name, slug, location } = this.props.trail;
    const trailObj = { ID: id, type: 'trail', name, slug };
    let initialCenter;
    if (location && location.zoom) {
      initialCenter = [location.latitude, location.longitude, location.zoom];
    }

    return (
      <Page context={this.props}>
        <div id="contribute-fullscreen" className="full-height">
          <div id="modalPortal" />
          {contributeBox}
            <MapExpandProvider>
              <ContributeMap
                context={this.props.context}
                currentPage={PageStrings.CONTRIBUTE_TRAIL}
                enabledOverlays={this.props.enabledOverlays}
                exploreMap={this.state.defaultMap}
                profilePhoto={this.state.defaultPhoto}
                handleOverlayToggled={this.handleOverlayToggled}
                hasAdminFeatures={this.state.hasAdminFeatures}
                id="contribute-map"
                initialCenter={initialCenter}
                mapboxAccessToken={this.props.mapboxAccessToken}
                mapDivId="map"
                handleWaypointAdded={this.handleWaypointAdded}
                mapMatchPolyline={this.props.mapMatchPolyline}
                mapProviderName="mapBox"
                messagingChannel={this.props.messagingChannel}
                plannerMap={this.state.routeInfo ? this.state.routeInfo.plannerMap : null}
                handleRouteInfoChanged={this.handleRouteInfoChanged}
                handleInsertRouteInfoChanged={this.handleInsertRouteInfoChanged}
                resultCardFunctions={this.resultCardFunctions}
                selectedObject={trailObj}
                setMapData={this.setMapData}
                setMapInitialData={this.setMapInitialData}
              />
            </MapExpandProvider>
        </div>
      </Page>
    );
  }
});

ContributeTrailApp.defaultProps = {
  enabledOverlays: [],
  messagingChannel: postal.channel('contribute_messagingChannel')
};

export { ContributeTrailApp };
